import HotelApp from './HotelApp';

export default HotelApp;
